<h2 mat-dialog-title>
  {{ title }}
  <div class="subtitle text-muted ps-2">{{ submittedAt }}</div>
</h2>

<mat-dialog-content>
  <div class="py-2 px-2">

    <div class="no-print">
      <button mat-button (click)="printPDF()" class="secondary-gray-button mb-3 mt-2 me-2">
        <mat-icon>print</mat-icon> {{'print' | translate}}
      </button>
      <button mat-button (click)="openTemplate()" class="secondary-gray-button mb-3 mt-2">
        <mat-icon>open_in_new</mat-icon> {{'formResults.openTemplate' | translate}}
      </button>

      <mat-divider class="my-3"></mat-divider>
    </div>
    <!-- Printable content -->
    <div #printSection>
      <h2 class="d-none mb-0">{{ title }}</h2>
      <div class="d-none subtitle text-muted">{{ submittedAt }}</div>

      <mat-divider class="d-none my-3"></mat-divider>

      <h4 class="mb-4 text-secondary">{{'formResults.results' | translate}}: </h4>

      <table class="w-100">
        @for (item of entries; track item) {
          <tr>
            <td class="pe-3 align-top" style="width: 35%; font-weight: 600;">
              {{ item.key }}
            </td>
            <td class="align-top" style="white-space: pre-wrap;">
              {{ item.value }}
            </td>
          </tr>
        }
      </table>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="dialogClose()">
    {{ 'Close' | translate }}
  </button>
</mat-dialog-actions>